import { IconHourglassEmpty, IconHourglassOff } from '@tabler/icons-react'
import { useState, useEffect } from 'react'

interface ITrialHeaderProps {
  povEndDate?: string
}

function TrialHeader(props: ITrialHeaderProps) {
  const { povEndDate } = props
  const [trialExpired, setTrialExpired] = useState(false)
  const [povDaysRemaining, setPovDaysRemaining] = useState('0 days')

  useEffect(() => {
    if (!povEndDate) {
      setTrialExpired(true)
      setPovDaysRemaining('0 days')
      return
    }

    const formattedPovEndDate = new Date(povEndDate)
    const diff = formattedPovEndDate.getTime() - new Date().getTime()
    const diffDays = Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)))

    const word = diffDays === 1 ? 'day' : 'days'
    if (diffDays === 0) {
      setTrialExpired(true)
    }

    setPovDaysRemaining(`${diffDays} ${word}`)
  }, [povEndDate])

  return (
    <div
      className={`w-[100%] h-[42px] absolute top-0 left-0 flex items-center justify-center ${trialExpired ? 'bg-backgroundRed' : 'bg-backgroundYellow'}`}
    >
      {trialExpired ? (
        <IconHourglassOff size="16" className={`mr-2.5 text-textRed dark:text-white`} />
      ) : (
        <IconHourglassEmpty size="16" className={`mr-2.5 text-textYellow`} />
      )}
      <p className={`text-sm font-semibold ${trialExpired ? 'text-textRed dark:text-white' : 'text-textYellow'}`}>
        {trialExpired
          ? 'Your trial has expired - Please contact our team'
          : `${povDaysRemaining} left of Trial - Contact our team to learn more or get help`}
      </p>
    </div>
  )
}

export default TrialHeader
